import { render } from "./GetYourWishPage.vue?vue&type=template&id=1f726375&scoped=true&ts=true"
import script from "./GetYourWishPage.vue?vue&type=script&lang=ts"
export * from "./GetYourWishPage.vue?vue&type=script&lang=ts"

import "./GetYourWishPage.vue?vue&type=style&index=0&id=1f726375&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f726375"]])

export default __exports__